export interface PurchaseOrderLineForCompleting {
  id: string;
  purchaseOrderAndLineNo: number;
  supplierAccount: string;
  supplierName: string;
  supplierOrderNo: string;
  supplierOrderRef: string;
  orderTypeDescription: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  noOfItems: number;
  quantity: number;
  uom: string;
  price: number;
  discount: number;
  deliveryDate: Date;
  receivedQuantity: number;
  balanceToDeliver: number;
  colour: string;
}
